import { render, staticRenderFns } from "./PlanejamentoAcaoVerbaVariavelFormOrigemAcao.vue?vue&type=template&id=50ff61d5"
import script from "./PlanejamentoAcaoVerbaVariavelFormOrigemAcao.vue?vue&type=script&lang=js"
export * from "./PlanejamentoAcaoVerbaVariavelFormOrigemAcao.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoAcaoVerbaVariavelFormOrigemAcao.vue?vue&type=style&index=0&id=50ff61d5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports